import FileSaver from "file-saver";

import api from "@/api";
import deepClone from "@/utils/deep-clone";

const state = {
    list: [],
};

const getters = {
    list(state) {
        return () => {
            return deepClone(state.list);
        };
    },
};

const actions = {
    get({ commit, state }, { payload: { offset = 0, userFilter = {} } }) {
        return api.post(`/api/users/list`, { userFilter, offset }).then(res => {
            let list;
            if (offset) {
                list = getters
                    .list(state)()
                    .concat(res.data);
            } else {
                list = res.data || [];
            }

            commit("updateList", { list });
        });
    },

    reset({ commit }, { payload: { key } }) {
        commit("updateList", { key, list: [] });
    },

    export(_, { payload: { team } }) {
        return api
            .get(`/api/users/list/export/${team}`, { responseType: "arraybuffer" })
            .then(res => {
                const date = new Date();
                const filename = "User-Export-" + date.toLocaleDateString("de") + ".xlsx";

                FileSaver.saveAs(
                    new Blob([res.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    }),
                    filename,
                );
            });
    },

    exportOneTimePasswords() {
        return api
            .get(`/api/users/password/exportOneTimePasswords`, { responseType: "arraybuffer" })
            .then(res => {
                const date = new Date();
                const filename =
                    "User-OneTimePassword-Export-" + date.toLocaleDateString("de") + ".xlsx";

                FileSaver.saveAs(
                    new Blob([res.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    }),
                    filename,
                );
            });
    },
};

const mutations = {
    updateList(state, { list }) {
        state.list = [...list];
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
